(function HotelEngineRoom($, Adzuki)
{
    'use strict';

    const component = {
        inject: {
            $inject_loggedIn: {
                default: false
            },
            setLoggedIn: {
                default: () => undefined
            },
            selectRoom: {
                default: () => undefined
            }
        },
        provide() {
            return {
                onLoginSuccess: () => this.onLoginSuccess(),
            };
        },
        props: {
            giataId: {
                type    : Number,
                required: true,
            },
            roomName: {
                type    : String,
                required: true,
            },
            roomDetails: {
                type    : Object,
                required: true,
            },
            criteria: {
                type    : Object,
                required: true,
            },
            showPayLater: {
                type   : Boolean,
                default: false
            }
        },
        template: `
              <div class="hotel-details-room-card-inner">
                <div class="rate-options">
                  <div class="hotel-details-room-body">
                    <div class="hotel-details-room-header">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-2 hotel-details-room-image-col">
                          <div v-if="roomDetails.images && roomDetails.images.length" class="hotel-details-room-image-wrap">
                            <adzuki-carousel
                                v-if="roomDetails.images && roomDetails.images.length"
                                :images="roomDetails.images"
                                :show-case-options="{
                                    show: false,
                                }"
                                :carousel-options="{
                                    show: true,
                                    mode: 'single',
                                }"
                            ></adzuki-carousel>
                          </div>
                          <div
                              v-else
                              class="hotel-details-room-no-img"
                              :style="{ backgroundImage: 'url(' + baseUri + '/images/no-hotel-image-available.png)' }"
                          >
                          </div>
                        </div>
                        <div class="room-name col-xs-12 col-sm-12 col-md-10">
                          <h3 class="hotel-details-room-name">{{ roomName }}</h3>
                          <span v-if="additionalInformation" class="text-muted more-details margin5-vert" v-html="additionalInformation"></span>
                          <div class="room-amentities-container margin10-vert" v-if="roomAmenities.length > 0">
                            <div class="room-amenities-list">
                              <span class="badge badge-pill badge-secondary margin5-bottom"
                                v-for="(amenity, index) in visibleAmenities" :key="index">
                                {{ amenity }}
                              </span>
                            </div>
                            <div class="more-amenities-container" v-if="showAllAmenities">
                              <span
                                  class="badge badge-pill badge-secondary margin5-bottom"
                                  v-for="(amenity, index) in hiddenAmenities"
                                  :key="index"
                              >
                                {{ amenity }}
                              </span>
                            </div>
                            <p class="room-amenities-toggle" v-if="hiddenAmenities.length > 0">
                              <a href="#" @click.prevent="showAllAmenities = !showAllAmenities">{{showAllAmenities ? 'Hide' : 'Show'}} all amenities</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="hotel-details-room-rates-section">
                    <template v-if="bestValueRates.length">
                      <table class="table table-striped margin10-top hotel-details-rates-table">
                        <thead>
                          <tr>
                            <th class="text-center">Refundable</th>
                            <th v-if="showPayLater" class="text-center">Eligible to Pay Later</th>
                            <th class="text-center">Included</th>
                            <th class="text-center">Per Night</th>
                            <th class="text-center">Total Price</th>
                            <th class="text-center">Rooms Available</th>
                            <th class="text-center">More Information</th>
                            <th class="text-center"></th>
                          </tr>
                        </thead>
                        <tbody class="hotel-engine-room-rates">
                          <template
                              v-for="(rate, rateIdx) in bestValueRates"
                              :key="rateIdx"
                          >
                          <tr
                              class="hotel-details-rate-block"
                              :class="{ 'hotel-details-rate-block--expanded': expandedRateIndex === rateIdx }"
                          >
                            <td class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value">
                                  <template v-if="rate.refundable">
                                    <i class="fa fa-check text-success" aria-hidden="true"></i>
                                    <template v-if="cancellationPolicies[rateIdx][0] && cancellationPolicies[rateIdx][0].end_date">
                                      Free cancellation before <span v-format-date="cancellationPolicies[rateIdx][0].end_date"></span>
                                    </template>
                                    <template v-else>
                                      Refundable
                                    </template>
                                  </template>
                                  <span v-else class="text-danger">
                                    <i class="fa fa-warning text-danger" aria-hidden="true"></i> Non-refundable
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td v-if="showPayLater" class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value">
                                  <span v-if="rate.pay_later_eligible">
                                    Eligible for Pay Later
                                  </span>
                                  <span v-else>
                                    Not eligible for Pay Later
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value">{{ formatBoardInfo(rate) }}</div>
                              </div>
                            </td>
                            <td class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div
                                    class="hotel-details-rate-value"
                                    v-format-currency="roomPrices[rateIdx].per_night_per_room"
                                ></div>
                                <span 
                                    class="hotel-details-rate-disclaimer"
                                    v-if="roomPrices[rateIdx].savings > 0"
                                >
                                  Verified best rate
                                </span>

                              </div>
                            </td>
                            <td class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value hotel-details-rate-total">
                                  <span v-format-currency="roomPrices[rateIdx].totalCost"></span>
                                  <span class="hotel-details-rate-disclaimer">Includes taxes and fees</span>
                                </div>
                              </div>
                            </td>
                            <td class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value">
                                  {{ rate.available_rooms != null ? rate.available_rooms + ' or more' : '1 or more' }}
                                </div>
                              </div>
                            </td>
                            <td class="text-center hotel-details-rate-cell">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value">
                                  <a href="#"
                                     class="hotel-details-view-details"
                                     :class="{ 'hotel-details-view-details--active': expandedRateIndex === rateIdx }"
                                     @click.prevent="toggleRateDetails(rateIdx)">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                                    {{ expandedRateIndex === rateIdx ? 'Hide Details' : 'View Details' }}
                                  </a>
                                </div>
                              </div>
                            </td>
                            <td class="text-center hotel-details-rate-cell hotel-details-room-actions">
                              <div class="hotel-details-rate-row">
                                <div class="hotel-details-rate-value">
                                  <adzuki-loading
                                      v-if="loadingRateIndex === rateIdx"
                                      :loader-type="'button'"
                                      :button-class="'hotel-details-select-rate-btn hotel-book-now-btn'"
                                  ></adzuki-loading>
                                  <slot
                                      name="rate-action-button"
                                      :loadingRateIndex="loadingRateIndex"
                                      :rate="rate"
                                      :rateIdx="rateIdx"
                                      :selectRoom="selectRoom"
                                  >
                                    <button
                                        v-if="loadingRateIndex !== rateIdx"
                                        type="button"
                                        class="hotel-details-select-rate-btn hotel-book-now-btn"
                                        @click="chooseRoom(rateIdx, rate.rate_select_string)"
                                    >
                                      Select Rate
                                    </button>
                                  </slot>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="hotel-details-rate-accordion-row">
                            <td :colspan="rateTableColspan">
                              <div
                                  class="hotel-details-rate-accordion-wrap"
                                  :class="{ 'hotel-details-rate-accordion-wrap--open': expandedRateIndex === rateIdx }"
                              >
                                <div class="hotel-details-rate-accordion-inner">
                                  <div class="hotel-details-rate-accordion-content">
                                    <he-room-modal-content :rate="rate"></he-room-modal-content>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </template>
                        </tbody>
                      </table>
                    </template>

                    <div class="text-center" v-if="useMyTrips && additionalRates.length">
                      <a href='#' @click.prevent="seeAllRates">See more rates</a>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            <adzuki-modal
                v-if="showModal"
                :key="modalKey"
                :type="'component'"
                :modal-title="modalTitle"
                :component-name="componentToRender"
                :component-props="modalProps"
                @close-modal="closeModal"
                @component-event="handleEvent"
            ></adzuki-modal>
        `,
        data() {
            return {
                baseUri          : Adzuki.base_uri,
                useMyTrips       : Number(Adzuki.use_mytrips) === 1,
                showModal        : false,
                modalKey         : 0,
                componentToRender: null,
                modalTitle       : '',
                modalProps       : {},
                loadingRateIndex : null,
                showAllAmenities : false,
                expandedRateIndex: null,
            };
        },
        computed: {
            numNights() {
                const checkInDate  = new Date(this.criteria.check_in);
                const checkOutDate = new Date(this.criteria.check_out);

                // Ensure check-in date is earlier than check-out date
                if (checkOutDate <= checkInDate) {
                    return 0; // No nights if checkout is the same or earlier than check-in
                }

                // Calculate the difference in time (milliseconds)
                const timeDifference = checkOutDate - checkInDate;

                // Convert the time difference to days (1 day = 24 * 60 * 60 * 1000 ms)
                return timeDifference / (1000 * 60 * 60 * 24);

            },
            // Every list below is index-aligned with this one, so the template iterates it too.
            bestValueRates() {
                return this.toList(this.roomDetails?.best_value_rates);
            },
            additionalRates() {
                return this.toList(this.roomDetails?.all_rates);
            },
            roomPrices() {
                return Adzuki.HotelEngine.computeRatesPrices(
                    this.bestValueRates,
                    {
                        numNights: this.numNights || 1,
                        numRooms : this.criteria?.rooms?.length || 1,
                    }
                );
            },
            cancellationPolicies() {
                return this.bestValueRates.map((rate) => {
                    const policies = this.toList(rate?.cancellation_policies);

                    return policies.map((policy) => ({
                        ...policy,
                        end_date: policy.end_date
                            ? {
                                date   : policy.end_date,
                                options: {
                                    month: '2-digit',
                                    day  : '2-digit',
                                    year : 'numeric',
                                },
                            }
                            : null,
                    }));
                });
            },
            roomAmenities() {
                const roomAmenities = new Set();

                this.toList(this.roomDetails?.best_value_rates).forEach((rate) => {
                    this.toList(rate?.provider_data?.room_amenities).forEach((amenity) => {
                        const name = typeof amenity === 'string' ? amenity : amenity?.mapped_name;

                        if (name) {
                            roomAmenities.add(name);
                        }
                    });
                });

                return Array.from(roomAmenities);
            },
            visibleAmenities() {
                return this.roomAmenities.slice(0, 10);
            },
            hiddenAmenities() {
                return this.roomAmenities.slice(10);
            },
            rateAmenities() {
                const rateAmenities = new Set();

                this.toList(this.roomDetails?.best_value_rates).forEach((rate) => {
                    this.toList(rate?.provider_data?.rate_amenities).forEach((amenity) => {
                        const name = typeof amenity === 'string' ? amenity : amenity?.mapped_name;

                        if (name) {
                            rateAmenities.add(name);
                        }
                    });
                });

                return Array.from(rateAmenities);
            },
            additionalInformation() {
                const result = this.toList(this.roomDetails?.best_value_rates).map((rate) => {
                    const additionalInfo = [];

                    // Bed Types
                    const beds = [];

                    this.toList(rate?.provider_data?.beds).forEach((bed) => {
                        if (!bed?.size) {
                            return;
                        }

                        beds.push(bed.quantity ? `${bed.size} (${bed.quantity})` : bed.size);
                    });

                    if (beds.length > 0) {
                        additionalInfo.push(`<b>Bed Type(s):</b> ${beds.join(', ')}`);
                    }

                    // Occupancy
                    let occupancyCounter = 0;
                    if (rate.provider_data?.max_adults) {
                        occupancyCounter += rate.provider_data.max_adults;
                    }
                    if (rate.provider_data?.occupancy) {
                        occupancyCounter += rate.provider_data.occupancy;
                    }

                    if (occupancyCounter > 0) {
                        additionalInfo.push(`<b>Occupancy:</b> ${occupancyCounter}`);
                    }

                    // Square Feet
                    if (rate.provider_data?.square_feet) {
                        additionalInfo.push(`<b>Square Feet:</b> ${rate.provider_data.square_feet} sqft`);
                    }

                    // Return as HTML string with spacing, or null if no info
                    return additionalInfo.length > 0 ? additionalInfo.join('    ') : null;
                });

                // Remove duplicates using Set
                const uniqueResults = [...new Set(result.filter(item => item !== null && item !== ''))];

                // Return null if empty, otherwise return unique results
                return uniqueResults.length > 0 ? uniqueResults : null;
            },
            rateModalTitleHtml() {
                let html = `<h3 class="hotel-details-room-name">${this.roomName}</h3>`;

                if (this.additionalInformation?.length) {
                    html += `<span class="text-muted more-details margin5-vert">${this.additionalInformation.join('    ')}</span>`;
                }

                return html;
            },
            rateTableColspan() {
                return this.showPayLater ? 8 : 7;
            },
        },
        methods: {
            // Rate payloads send lists as an array, an object keyed by id, or nothing at all.
            toList(value) {
                if (Array.isArray(value)) {
                    return value.filter((item) => item !== null && item !== undefined);
                }

                if (value && typeof value === 'object') {
                    return Object.values(value).filter((item) => item !== null && item !== undefined);
                }

                return [];
            },
            isLoggedIn() {
                const loggedIn = this.$inject_loggedIn;
                return loggedIn && typeof loggedIn === 'object' && 'value' in loggedIn
                    ? Boolean(loggedIn.value)
                    : Boolean(loggedIn);
            },
            seeAllRates() {
                if (this.isLoggedIn()) {
                    this.openRateModal();
                } else {
                    this.openLoginModal();
                }
            },
            formatBoardInfo(rate) {
                const boardInfo = rate?.provider_data?.board_info;

                if (boardInfo && typeof boardInfo !== 'object') {
                    return String(boardInfo) || '—';
                }

                const items = this.toList(boardInfo)
                    .map((item) => String(item ?? '').trim())
                    .filter(Boolean);

                return items.length ? items.slice(0, 3).join(', ') : '—';
            },
            openRateModal() {
                this.modalTitle = this.rateModalTitleHtml;
                this.modalProps = {
                    rates       : this.additionalRates,
                    criteria    : this.criteria,
                    showPayLater: this.showPayLater
                };
                this.componentToRender = Vue.markRaw(Adzuki.VueComponents.HotelEngineRates);
                this.modalKey += 1;
                this.showModal = true;
            },
            openLoginModal() {
                this.modalTitle = 'Login to MyTrips';
                this.modalProps = {
                    allowsSignup: true
                };
                this.componentToRender = Vue.markRaw(Adzuki.VueComponents.AdzukiMyTripsLogin);
                this.modalKey += 1;
                this.showModal = true;
            },
            onLoginSuccess() {
                this.openRateModal();
            },
            toggleRateDetails(rateIndex) {
                this.expandedRateIndex = this.expandedRateIndex === rateIndex ? null : rateIndex;
            },
            closeModal() {
                this.showModal = false;
            },
            async handleEvent(event) {
                if (event.type === 'login') {
                    this.onLoginSuccess();
                } else if (event.type === 'book-room') {
                    const success = await this.selectRoom(event.rate_select_string);

                    if (!success) {
                        this.loadingRateIndex = null;
                    }
                }
            },
            async chooseRoom(rateIdx, rateString) {
                this.loadingRateIndex = rateIdx;

                const success = await this.selectRoom(rateString);

                if (!success) {
                    this.loadingRateIndex = null;
                }
            }
        }
    };

    Adzuki.VueComponents.HotelEngineRoom = component;
}(jQuery, window.Adzuki || {}));
